export default "__VITE_ASSET__soKsFntJ__"